var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0731 6V21.4286C28.0731 22.875 26.87 24 25.4481 24H2.69812C1.22156 24 0.0731201 22.875 0.0731201 21.4286V6C0.0731201 4.60714 1.22156 3.42857 2.69812 3.42857H7.51062L8.16687 1.71429C8.54968 0.696429 9.53406 0 10.6278 0H17.4637C18.5575 0 19.5419 0.696429 19.9247 1.71429L20.6356 3.42857H25.4481C26.87 3.42857 28.0731 4.60714 28.0731 6ZM20.6356 13.7143C20.6356 10.1786 17.6825 7.28571 14.0731 7.28571C10.4091 7.28571 7.51062 10.1786 7.51062 13.7143C7.51062 17.3036 10.4091 20.1429 14.0731 20.1429C17.6825 20.1429 20.6356 17.3036 20.6356 13.7143ZM18.8856 13.7143C18.8856 16.3393 16.6981 18.4286 14.0731 18.4286C11.3934 18.4286 9.26062 16.3393 9.26062 13.7143C9.26062 11.1429 11.3934 9 14.0731 9C16.6981 9 18.8856 11.1429 18.8856 13.7143Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIconBlack);
export default __webpack_public_path__ + "static/media/camera-icon-black.f9ea0d4461d4afc4049341fafab8154f.svg";
export { ForwardRef as ReactComponent };